import React from 'react';

import { useRouter } from 'react-resource-router';

import PullRequest from './containers/page';

const PullRequestRoute = () => {
  const [router] = useRouter();
  return <PullRequest {...router} />;
};

export default PullRequestRoute;
